import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Form,
  Input,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDrugTransferInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardDrugTransferInterfaceUX-div-0"
        style={{width: "calc(-180px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardDrugTransferInterfaceUX-div-1"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardDrugTransferInterfaceUX-Form-32">
            <FormGroup
              id="CardDrugTransferInterfaceUX-FormGroup-33"
              inline={true}
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-41"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-52">
                  {props.languageUX === "en" ? "Creation Date" : "วันที่สร้าง"}
                </label>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-42"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-51">
                  {props.languageUX === "en" ? "Product Code" : "รหัสสินค้า"}
                </label>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-43"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-50">
                  {props.languageUX === "en" ? "Source Storage Code" : "รหัสการเก็บข้อมูลต้นทาง"}
                </label>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-44"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-49">
                  {props.languageUX === "en" ? "Destination Storage Code" : "รหัสที่เก็บข้อมูลปลายทาง"}
                </label>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-45"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-48">
                  {props.languageUX === "en" ? "Vendor Code" : "รหัสผู้ขาย"}
                </label>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-46"
                width={2}>
                <label
                  id="CardDrugTransferInterfaceUX-label-47">
                  {"\u00A0"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDrugTransferInterfaceUX-FormGroup-34"
              inline={true}>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-35"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-59"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardDrugTransferInterfaceUX-DateTextBox-60"
                    onChange={props.onChangeDate}
                    value={props.searchDrugTransfer?.createdDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-36"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-57"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugTransferInterfaceUX-Input-61"
                    name="productCode"
                    onChange={props.onChangeData}
                    value={props.searchDrugTransfer?.productCode || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-37"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-56"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugTransferInterfaceUX-Input-62"
                    name="sourceCode"
                    onChange={props.onChangeData}
                    value={props.searchDrugTransfer?.sourceCode || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-38"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-55"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugTransferInterfaceUX-Input-63"
                    name="destinationCode"
                    onChange={props.onChangeData}
                    value={props.searchDrugTransfer?.destinationCode || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-39"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-54"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugTransferInterfaceUX-Input-64"
                    name="vendorCode"
                    onChange={props.onChangeData}
                    value={props.searchDrugTransfer?.vendorCode || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugTransferInterfaceUX-FormField-40"
                width={2}>
                <div
                  id="CardDrugTransferInterfaceUX-div-53"
                  style={{ width: "100%", display: "flex" }}>
                  
                  <div
                    id="CardDrugTransferInterfaceUX-div-65"
                    style={{ margin: "0px 20px" }}>
                    
                    <div
                      id="CardDrugTransferInterfaceUX-div-67">
                      {props.searchButton}
                    </div>
                  </div>
                  <div
                    id="CardDrugTransferInterfaceUX-div-66">
                    
                    <Button
                      color="orange"
                      id="CardDrugTransferInterfaceUX-Button-68"
                      onClick={props.onClearFilter}>
                      {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardDrugTransferInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.drugTransferInterfaceList}
            id="CardDrugTransferInterfaceUX-Table-4"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardDrugTransferInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardDrugTransferInterfaceUX-FormGroup-6"
            inline={true}
            style={{ display: "flex", justifyContent: "flex-end" }}>
            <FormField
              id="CardDrugTransferInterfaceUX-FormField-7">
              <div
                id="CardDrugTransferInterfaceUX-div-30">
                {props.addButton}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferInterfaceUX-FormField-8">
              <div
                id="CardDrugTransferInterfaceUX-div-31">
                {props.editButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardDrugTransferInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:47:14 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-180px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.drugTransferInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Table-4"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Form-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormGroup-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormGroup-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-35"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-36"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-37"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-38"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-39"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-40"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-41"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-42"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-43"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-44"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-45"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-FormField-46"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผู้ขาย",
          "valueEN": "Vendor Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสที่เก็บข้อมูลปลายทาง",
          "valueEN": "Destination Storage Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสการเก็บข้อมูลต้นทาง",
          "valueEN": "Source Storage Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสสินค้า",
          "valueEN": "Product Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง",
          "valueEN": "Creation Date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-label-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 60,
      "name": "DateTextBox",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-DateTextBox-60"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugTransfer?.createdDate"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Input",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Input-61"
        },
        "name": {
          "type": "value",
          "value": "productCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugTransfer?.productCode || \"\""
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Input-62"
        },
        "name": {
          "type": "value",
          "value": "sourceCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugTransfer?.sourceCode || \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Input-63"
        },
        "name": {
          "type": "value",
          "value": "destinationCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugTransfer?.destinationCode || \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Input-64"
        },
        "name": {
          "type": "value",
          "value": "vendorCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugTransfer?.vendorCode || \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-div-67"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Button",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferInterfaceUX-Button-68"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 68,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardDrugTransferInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
